
import { AxiosResponse } from 'axios';
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import axios from "../../../lib/axios";
import { TResponse } from "../../../types/common";
import { IPagePayload } from '../../../types/api/pages';


export async function savePage(data: IPagePayload): Promise<AxiosResponse<TResponse<IPagePayload>>> {
    return axios.post<TResponse<IPagePayload>>(API_ENDPOINTS.PAGE_SAVE, data)
}

export async function detailPage(type:string): Promise<AxiosResponse<TResponse<IPagePayload>>> {
    return axios.get(`${API_ENDPOINTS.PAGE_DETAIL}/${type}`)
}

